import Vue from 'vue'
import moment from 'moment'

Vue.filter('moment', function (value, istime) {
  if (!value) {
    return ''
  }
  if (istime) {
    return moment(value).format('YYYY-MM-DD')
  } else {
    return moment(value).format('YYYY')
  }
})



//////////////////
// WEBPACK FOOTER
// ./static/filter/formatDate.js
// module id = null
// module chunks = 